import { checkResolution } from "Functions/helpers"
import { updateLazy } from "Functions/lazy"
import { scrollToEl } from "Functions/window"

import "Layouts/default"

import 'Common/paginator'

const attachPaginatorEvents = () => {
    for (const pagerButton of document.querySelectorAll('.pager__list .c-btn')) {
        if (pagerButton.classList.contains('is-active')) continue

        pagerButton.addEventListener('click', (event) => {
            scrollToEl(document.querySelector('.l-articles__content'), (checkResolution('cxs;xs') ? 0 : 40))
        })
    }
}

attachPaginatorEvents()

rEvent.on('Listing.fetchedData', () => {
    updateLazy()
    attachPaginatorEvents()
})